export default function SelectedTag({ tag }) {
  return <div className="bg-green-100 py-1 px-4 rounded-full">{tag}</div>;
}
